const React = require('react')
const classNames = require('classnames')
const PropTypes = require('prop-types')
const MetaItem = require('./meta_item')

function MetaSection(props) {

    const { label, items } = props

    const className = classNames([
        'meta-section',
        props.type,
    ])

    return (
        <li className={className}>
            <div className="meta-header">
                {label}
            </div>
            <ul className="meta-list">
                {items.map((item, i) => <MetaItem key={i} text={item} />)}
            </ul>
        </li>
    )
}

MetaSection.propTypes = {
    type: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    items: PropTypes.array.isRequired,
}

module.exports = MetaSection
